module.exports = __webpack_public_path__ + "img/logo-01.18541c4f.png";